import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const faqConfig = {
  /* ------------------------------- GET ---------------------------------- */

  getFAQs: {
    key: "getFAQs",
    url: "/api/v1/faq",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getFAQById: {
    key: "getFAQById",
    url: (data) => `/api/v1/faq/${data.id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  getDeletedFAQs: {
    key: 'getDeletedFAQs',
    url: '/api/v1/faq/deleted',
    method: 'GET',
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  /* ------------------------------- POST ---------------------------------- */

  createFAQ: {
    key: "createFAQ",
    url: "/api/v1/faq",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getFAQs"],
      onSuccessMessage: "FAQ created successfully",
      onErrorMessage: "Failed to create FAQ",
    },
  },

  restoreFAQ: {
    key: "restoreFAQ",
    url: (data) => `/api/v1/faq/${data.id}/restore`,
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getFAQs", "getDeletedFAQs"],
      onSuccessMessage: "FAQ restored successfully",
      onErrorMessage: "Failed to restore FAQ",
    },
  },

  /* ------------------------------- PUT ---------------------------------- */

  updateFAQ: {
    key: "updateFAQ",
    url: (data) => `/api/v1/faq/${data.id}`,
    method: "PUT",
    options: {
      retry: 2,
      invalidateKeys: ["getFAQs", "getFAQById"],
      onSuccessMessage: "FAQ updated successfully",
      onErrorMessage: "Failed to update FAQ",
    },
  },

  /* ------------------------------- DELETE ---------------------------------- */

  deleteFAQ: {
    key: "deleteFAQ",
    url: (data) => `/api/v1/faq/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getFAQs", "getDeletedFAQs"],
      onSuccessMessage: "FAQ deleted successfully",
      onErrorMessage: "Failed to delete FAQ",
    },
  },
};
